const HeroBackground = () => {
  return (
    <div className="absolute inset-0 z-[1] pointer-events-none overflow-hidden hidden md:block">
      {/* Ambient glow orbs — right side */}
      <div className="absolute -top-10 right-0 w-[500px] h-[500px] rounded-full bg-primary/[0.08] blur-[120px] animate-hero-drift-1" />
      <div className="absolute top-1/3 right-10 w-[300px] h-[300px] rounded-full blur-[100px] animate-hero-drift-1" style={{ background: 'hsl(180, 70%, 55%, 0.06)' }} />

      {/* Flowing SVG wave lines — exactly 4 thick lines */}
      <svg
        viewBox="0 0 1200 800"
        preserveAspectRatio="none"
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="hero-glow-intense">
            <feGaussianBlur stdDeviation="4" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>

          <linearGradient id="grad-purple-cyan" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(270, 80%, 65%)" />
            <stop offset="100%" stopColor="hsl(180, 70%, 55%)" />
          </linearGradient>
          <linearGradient id="grad-blue-pink" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(220, 80%, 60%)" />
            <stop offset="100%" stopColor="hsl(320, 70%, 65%)" />
          </linearGradient>
          <linearGradient id="grad-cyan-violet" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(185, 75%, 55%)" />
            <stop offset="100%" stopColor="hsl(280, 70%, 60%)" />
          </linearGradient>
          <linearGradient id="grad-pink-blue" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(330, 70%, 60%)" />
            <stop offset="100%" stopColor="hsl(210, 80%, 60%)" />
          </linearGradient>
        </defs>

        <g filter="url(#hero-glow-intense)" className="opacity-25">
          {/* Line 1 — top, full sweep */}
          <path
            d="M-50,80 C200,20 400,160 600,100 S900,30 1250,90"
            fill="none"
            stroke="url(#grad-purple-cyan)"
            strokeWidth="4.5"
            strokeLinecap="round"
            className="animate-hero-flow"
          />
          {/* Line 2 */}
          <path
            d="M-50,200 C180,130 420,280 650,210 S880,140 1250,220"
            fill="none"
            stroke="url(#grad-blue-pink)"
            strokeWidth="4"
            strokeLinecap="round"
            className="animate-hero-flow hidden lg:block"
            style={{ animationDelay: '2s' }}
          />
          {/* Line 3 */}
          <path
            d="M650,310 C720,270 800,390 900,340 S1020,280 1250,370"
            fill="none"
            stroke="url(#grad-cyan-violet)"
            strokeWidth="4"
            strokeLinecap="round"
            className="animate-hero-flow hidden lg:block"
            style={{ animationDelay: '4s' }}
          />
          {/* Line 4 — bottom sweep */}
          <path
            d="M630,440 C710,390 820,520 920,460 S1040,400 1250,500"
            fill="none"
            stroke="url(#grad-pink-blue)"
            strokeWidth="4.5"
            strokeLinecap="round"
            className="animate-hero-flow hidden lg:block"
            style={{ animationDelay: '6s' }}
          />
        </g>
      </svg>
    </div>
  );
};

export default HeroBackground;
